import _ from "../../../../lib/lodash.custom.min";
import {zeroPad} from "../modules/util";

/*
 * stateが変わったらそれに依存して別のstateを変えるための関数群
 */ 
export default {
	setCalendarCount: function(ev) {
		ev.data.state.set({calendarCount: calendarCount(ev.data)});
	},
	setFirstPage: function(ev) {
		if(!ev.data.state.skipSetFirstPage) {
			ev.data.state.set({page: 1});
		}
		ev.data.state.skipSetFirstPage = false;
	},
	setFirstReviewPage: function(ev) {
		ev.data.state.set({reviewPage: 1});
	},
	uncheckDestOption: function(ev) {
		if (!ev.data.state.city0) {
			ev.data.state.set({_onlyhere: []});
		}
	}
};

function calendarCount(store) {
	var state = store.state;
	var ymCurrent = state.ymCurrent;
	var ymNext = state.ymNext;
	var count = state.CalendarState.dateCount;
	var countNext = state.CalendarState.dateCountNext;
	const calendar = store.def.calendar;
	const calendarCount = Object.assign(
		monthCountToHash(ymCurrent, count, calendar),
		monthCountToHash(ymNext, countNext, calendar)
	);
	if (state.checkStock && state.ConditionState) {
		const total = +state.ConditionState.dataCount[0];
		calendarCount[yyyymmddToDateCode(store.state.date)] = total;
	}
	return calendarCount;
}

function monthCountToHash(yyyymm, counts, calendar) {
	var result = {};
	var yyyymmStr = String(yyyymm);
	const month = yyyymmStr.slice(4, 6);
	const firstDateObj = _.find(calendar, {month: remove0pad(month)});
	const firstDate = firstDateObj && Number(firstDateObj.date);
	_.each(counts, function(count, idx) {
		result[toDateCode(yyyymmStr.slice(0, 4), yyyymmStr.slice(4, 6), firstDate + idx)] = Number(count);
	});
	return result;
}

function yyyymmddToDateCode(yyyymmdd) {
	return toDateCode(yyyymmdd.slice(0, 4), yyyymmdd.slice(4, 6), yyyymmdd.slice(6, 8));
}

function remove0pad(num) {
	return String(Number(num));
}

function toDateCode(year, month, date) {
	return [
		year,
		zeroPad(month),
		zeroPad(date)
	].join("-");
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/state-action.js